import { useState } from 'react'
import { KeyRound, X } from 'lucide-react'
import { motion, AnimatePresence } from 'framer-motion'
import type { SecretNudge } from '@/types/storytelling'

interface StorySecretNudgeProps {
  nudge: SecretNudge
}

export function StorySecretNudge({ nudge }: StorySecretNudgeProps) {
  const [dismissed, setDismissed] = useState(false)
  if (dismissed) return null

  return (
    <AnimatePresence>
      <motion.div initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, y: -10 }} className="rounded-xl p-4 flex gap-3 items-start" style={{ background: 'linear-gradient(135deg, var(--color-story-bg), var(--color-story-bg-light))', border: '1px solid var(--color-story-border)' }}>
        <div className="w-8 h-8 rounded-lg flex items-center justify-center flex-shrink-0" style={{ background: 'linear-gradient(135deg, var(--color-story-accent), #D49A2E)' }}>
          <KeyRound className="w-4 h-4 text-amber-900" />
        </div>
        <div className="flex-1 min-w-0">
          <p className="text-xs font-semibold" style={{ color: 'var(--color-story-primary)' }}>Story Secret: {nudge.secret.title}</p>
          <p className="text-xs mt-1 leading-relaxed" style={{ color: 'var(--color-story-text-muted)' }}>{nudge.suggestion}</p>
        </div>
        <button onClick={() => setDismissed(true)} className="flex-shrink-0 p-1 rounded-md transition-colors hover:bg-white/50" style={{ color: 'var(--color-story-text-muted)' }}>
          <X className="w-3.5 h-3.5" />
        </button>
      </motion.div>
    </AnimatePresence>
  )
}
